import { ResponseError } from "../errors/request-error";
import handleResponseError from "./apis/handle-response-error";
import HttpRequestBuilder from "./http-request-builder";
const httpStatusCheck = (response, request) => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    if (process.env.NODE_ENV === "development") {
        console.group(`Asynchronous request failed!`);
        console.log(`URL was ${response.url}`);
        console.log(`Status code: ${response.status}`);
        console.log(`Request:`, request);
        console.groupEnd();
    }
    throw new ResponseError(response, String(response.status));
};
const httpStateContext = {
    requestForgeryToken: undefined,
};
export const context = () => ({ ...httpStateContext });
export const contextualize = (response) => {
    httpStateContext.requestForgeryToken =
        response.requestForgeryToken || httpStateContext.requestForgeryToken;
    return response;
};
export const raw = (url, options) => fetch(url, options).then((response) => httpStatusCheck(response, options));
const noContentCodes = ["202", "204"];
export const json = (url, options) => raw(url, options)
    .then((response) => {
    if (noContentCodes.includes(String(response.status)))
        return null;
    return response.json();
})
    .catch((err) => {
    if (err instanceof ResponseError) {
        return handleResponseError(err);
    }
    throw err;
});
export const captureStateContext = (promise) => promise.then(contextualize);
export const builder = () => new HttpRequestBuilder();
